import { render, staticRenderFns } from "./TaxonomyTable.vue?vue&type=template&id=1fee1bd8&"
import script from "./TaxonomyTable.vue?vue&type=script&lang=js&"
export * from "./TaxonomyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports